// Papers and homework from the student's teachers. A paper a teacher has just
// set goes first — it is what the student was sent here for — then homework;
// the card keeps its existing start/resume/report behaviour unchanged.
import { TeacherPapersCard } from '@/components/dashboard/TeacherPapersCard';
import { HomeworkList } from '@/components/dashboard/HomeworkFromTeacher';
import { StudentPage, StudentPageHeader } from '@/components/ds';

export function AssignedPapersPage() {
  return (
    <StudentPage className="gap-4">
      <StudentPageHeader
        title="Assigned papers"
        subtitle="Homework and papers from your teachers."
      />
      <TeacherPapersCard />
      <HomeworkList />
    </StudentPage>
  );
}
